var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apps"},[_c('a',{style:({'background-color': _vm.color}),attrs:{"href":_vm.storeLinks.appStore}},[_c('img',{attrs:{"src":require("@/assets/external/appstore.svg")}})]),_c('a',{style:({'background-color': _vm.color}),attrs:{"href":_vm.storeLinks.googlePlay}},[_c('img',{attrs:{"src":require("@/assets/external/google.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }